/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { createDialogRoute, FormState, FormStateBuilder } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { DialogInput, getControlValue } from '@gh/core-ui';
import { getUserFinderListItemId } from '../../';
import {
  UserFinderBusinessService,
  UserFinderDialogConfig,
} from '../../resources/user-finder-business.service';
import { UserFinderListItem } from '../../resources/user-finder.model';
import { UserFinderGridDefinition } from './user-finder-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-user-finder-dialog',
  templateUrl: 'user-finder-dialog.component.html',
  styleUrls: ['user-finder-dialog.component.scss'],
  providers: [UserFinderGridDefinition],
})
export class UserFinderDialogComponent extends AbstractFinderDialogComponent<UserFinderDialogConfig, UserFinderListItem>
  implements OnInit, DialogInput<UserFinderDialogConfig> {

  form: FormState<any>;

  getId = getUserFinderListItemId;

  defaultTitle = this.translations.get('lbl_find_user');

  constructor(formStateBuilder: FormStateBuilder,
              private translations: TranslationService,
              public gridDefinition: UserFinderGridDefinition,
              private dialogRef: MatDialogRef<any>,
              private businessService: UserFinderBusinessService) {
    super(dialogRef);

    this.form = formStateBuilder.buildPlain({
      children: {
        name: void 0,
      },
    });
  }

  protected buildDataSource(): SlicedDataSource<UserFinderListItem> {
    const name = getControlValue(this.form.group, 'name');

    return this.businessService.findAllAsDataSource({
      ...this.input.filter,
      autocomplete: true,
      name,
    });
  }
}

export const userFinderDialogRoute = createDialogRoute({
  component: UserFinderDialogComponent,
});
